import kawasan1 from "../../media/kawasan sumbek/kawasan (1).png";
import kawasan2 from "../../media/kawasan sumbek/kawasan (2).png";
import kawasan3 from "../../media/kawasan sumbek/kawasan (3).png";
import kawasan4 from "../../media/kawasan sumbek/kawasan (4).png";
import kawasan5 from "../../media/kawasan sumbek/kawasan (5).png";
import kawasan6 from "../../media/kawasan sumbek/kawasan (6).png";
import kawasan7 from "../../media/kawasan sumbek/kawasan (7).png";
import kawasan8 from "../../media/kawasan sumbek/kawasan (8).png";
import kawasan9 from "../../media/kawasan sumbek/kawasan (9).png";
import kawasan10 from "../../media/kawasan sumbek/kawasan (10).png";
import kawasan11 from "../../media/kawasan sumbek/kawasan (11).png";
import kawasan12 from "../../media/kawasan sumbek/kawasan (12).png";
import kawasan13 from "../../media/kawasan sumbek/kawasan (13).png";
import kawasan14 from "../../media/kawasan sumbek/kawasan (14).png";
import kawasan15 from "../../media/kawasan sumbek/kawasan (15).png";
import kawasan16 from "../../media/kawasan sumbek/kawasan (16).png";

const suroundingimages = [
  kawasan1,
  kawasan2,
  kawasan3,
  kawasan4,
  kawasan5,
  kawasan6,
  kawasan7,
  kawasan8,
  kawasan9,
  kawasan10,
  kawasan11,
  kawasan12,
  kawasan13,
  kawasan14,
  kawasan15,
  kawasan16,
];

export default suroundingimages;
